import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../../utils/config";

export const getListRank = createAsyncThunk(
  "customer/rankcustomer/getListRank",
  async ({ currentPage, pageSize, value }) => {
    try {
      const apiUrl =
        value === undefined
          ? `/mcoupon/api/v1/membership-class-cms?has_paginate&size=${pageSize}&page=${currentPage}`
          : `/mcoupon/api/v1/membership-class-cms?branch_id=${value}&has_paginate&size=${pageSize}&page=${currentPage}`;
      const response = await http.get(apiUrl);
      
      return response.data;
    } catch (error) {
      throw new Error("Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);
export const getListRankAll = createAsyncThunk(
  "customer/rankcustomer/getListRankAll",
  async (value) => {
    try {
      const apiUrl =
        value === undefined
          ? "/mcoupon/api/v1/membership-class-cms"
          : `/mcoupon/api/v1/membership-class-cms?branch_id=${value}`;
      const response = await http.get(apiUrl);
      return response.data;
    } catch (error) {
      throw new Error("Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);
export const createRankCustomer = createAsyncThunk(
  "customer/rankcustomer/createRankCustomer",
  async (data, { rejectWithValue }) => {
    try {
      // data là FormData (có kèm file ảnh) -> gửi multipart, ảnh lưu ngay trong request tạo.
      const config =
        data instanceof FormData
          ? { headers: { "Content-Type": "multipart/form-data" } }
          : {};
      const response = await http.post(
        `/mcoupon/api/v1/membership-class`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || {});
    }
  }
);
export const deleteRankCustomer = createAsyncThunk(
  "customer/rankcustomer/deleteRankCustomer",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(
        `/mcoupon/api/v1/membership-class/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editRank = createAsyncThunk(
  "customer/rankcustomer/editRank",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      // PHP không parse multipart cho PUT -> dùng POST + _method=PUT (method spoofing).
      formData.append("_method", "PUT");
      const response = await http.post(
        `/mcoupon/api/v1/membership-class/${id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || {});
    }
  }
);
